import {
  TREATMENTS_PATTERN_DATES_GET_REQUEST,
  TREATMENTS_PATTERN_DATES_GET_SUCCESS,
  TREATMENTS_PATTERN_DATES_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import { queryStringBuilder } from '../../../utils/helpers';

export function getPatternDates(treatmentId, pattern, selectionMatrix, timeSlotsPackageId) {
  return {
    types: [
      TREATMENTS_PATTERN_DATES_GET_REQUEST,
      TREATMENTS_PATTERN_DATES_GET_SUCCESS,
      TREATMENTS_PATTERN_DATES_GET_FAILURE,
    ],
    buildCallParameters: () => {
      const base64TreatmentPatternDto = btoa(JSON.stringify(pattern));
      const base64SelectionMatrix = btoa(JSON.stringify(selectionMatrix));
      return {
        method: HTTP_METHOD.GET,
        path: `v1/query/GetPatternDates${queryStringBuilder({
          treatmentId,
          base64TreatmentPatternDto,
          timeSlotsPackageId,
          specificSelectedDays: pattern.isSpecific ? base64SelectionMatrix : undefined,
          timeSlotsMatrix: pattern.isSpecific ? undefined : base64SelectionMatrix,
        })}`,
      };
    },
  };
}
